import React, { useState } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";

const TimerCarousel = () => {
  const [activeTab, setActiveTab] = useState("pre");

  return (
    <div className="container py-5">
      {/* Tabs */}
      <div className="d-flex justify-content-between mb-4 flex-wrap overflow-auto" style={{ gap: '0.5rem' }}>
        <button
          className={`btn flex-fill mx-1 ${activeTab === "pre" ? "btn-warning" : "btn-light"}`}
          onClick={() => setActiveTab("pre")}
          style={{ minWidth: '150px', whiteSpace: 'nowrap' }}
        >
          ❤️ Pre/Post Workout
        </button>
        <button
          className={`btn flex-fill mx-1 ${activeTab === "on" ? "btn-warning" : "btn-light"}`}
          onClick={() => setActiveTab("on")}
          style={{ minWidth: '150px', whiteSpace: 'nowrap' }}
        >
          ⏱ On-The-Go
        </button>
        <button
          className={`btn flex-fill mx-1 ${activeTab === "daily" ? "btn-warning" : "btn-light"}`}
          onClick={() => setActiveTab("daily")}
          style={{ minWidth: '150px', whiteSpace: 'nowrap' }}
        >
          👤 Daily Hydration
        </button>
        <button
          className={`btn flex-fill mx-1 ${activeTab === "meals" ? "btn-warning" : "btn-light"}`}
          onClick={() => setActiveTab("meals")}
          style={{ minWidth: '150px', whiteSpace: 'nowrap' }}
        >
          🍽 With Meals
        </button>
      </div>

      {/* Content */}
      <div className="card shadow-sm border-0 p-4">
        {activeTab === "pre" && (
          <div className="row d-flex align-items-center flex-column flex-md-row">
            <div className="col-12 col-md-6 mb-3 mb-md-0">
              <h3 style={{ fontSize: '1.5rem' }}>Pre/Post Workout</h3>
              <p style={{ fontSize: '1rem' }}>Optimize your exercise with enhanced hydration before, during, and after your workouts.</p>

              <div className="mb-3 p-3 bg-light rounded shadow-sm">
                <h6><b>Benefits</b></h6>
                <p>Fusion Drinks help maintain electrolyte balance during intense activity and support muscle recovery afterward.</p>
              </div>

              <div className="mb-3 p-3 bg-light rounded shadow-sm">
                <h6><b>Recommended Flavors</b></h6>
                <p>Fusion Orange before workouts for energy, Fusion Cranberry after for recovery.</p>
              </div>

              <div className="p-3 bg-light rounded shadow-sm fst-italic">
                "I've tried many hydration drinks, but Fusion gives me the sustained energy I need without the crash."
                <br />
                <span className="text-warning fw-bold">Rahul K., Fitness Trainer</span>
              </div>
            </div>
            <div className="col-12 col-md-6 d-flex justify-content-center">
              <img
                src="https://images.unsplash.com/photo-1593079831268-3381b0db4a77"
                alt="Workout"
                className="img-fluid rounded shadow"
                style={{ maxWidth: '300px', width: '100%' }}
              />
            </div>
          </div>
        )}

        {activeTab === "on" && (
          <div className="row d-flex align-items-center flex-column flex-md-row">
            <div className="col-12 col-md-6 mb-3 mb-md-0">
              <h3 style={{ fontSize: '1.5rem' }}>On-The-Go</h3>
              <p style={{ fontSize: '1rem' }}>Stay hydrated during your busy day with a convenient, delicious refreshment.</p>

              <div className="mb-3 p-3 bg-light rounded shadow-sm">
                <h6><b>Benefits</b></h6>
                <p>Perfect for commutes, travel, or busy days when you need quick, effective hydration without added sugar.</p>
              </div>

              <div className="mb-3 p-3 bg-light rounded shadow-sm">
                <h6><b>Recommended Flavors</b></h6>
                <p>Fusion Mango or Fusion Litchi for a refreshing boost during your commute or travel.</p>
              </div>

              <div className="p-3 bg-light rounded shadow-sm fst-italic">
                "As a frequent traveler, I always keep Fusion in my bag. It's the perfect hydration companion."
                <br />
                <span className="text-warning fw-bold">Priya M., Tech Entrepreneur</span>
              </div>
            </div>
            <div className="col-12 col-md-6 d-flex justify-content-center">
              <img
                src="https://images.unsplash.com/photo-1593079831268-3381b0db4a77"
                alt="Workout"
                className="img-fluid rounded shadow"
                style={{ maxWidth: '300px', width: '100%' }}
              />
            </div>
          </div>
        )}
        {activeTab === "daily" && (
          <div className="row d-flex align-items-center flex-column flex-md-row">
            <div className="col-12 col-md-6 mb-3 mb-md-0">
              <h3 style={{ fontSize: '1.5rem' }}>Daily Hydration</h3>
              <p style={{ fontSize: '1rem' }}>Elevate your everyday hydration routine with flavorful, functional drinks.</p>

              <div className="mb-3 p-3 bg-light rounded shadow-sm">
                <h6><b>Benefits</b></h6>
                <p>Replace sugary beverages with a delicious option that supports your daily hydration needs at work, study, or home.</p>
              </div>

              <div className="mb-3 p-3 bg-light rounded shadow-sm">
                <h6><b>Recommended Flavors</b></h6>
                <p>Any Fusion flavor works perfectly for daily hydration - rotate them for variety!</p>
              </div>

              <div className="p-3 bg-light rounded shadow-sm fst-italic">
                "Since switching to Fusion for my daily water intake, I've noticed improved energy and focus throughout the day."
                <br />
                <span className="text-warning fw-bold">Arjun S., Software Developer</span>
              </div>
            </div>
            <div className="col-12 col-md-6 d-flex justify-content-center">
              <img
                src="https://images.unsplash.com/photo-1593079831268-3381b0db4a77"
                alt="Workout"
                className="img-fluid rounded shadow"
                style={{ maxWidth: '300px', width: '100%' }}
              />
            </div>
          </div>
        )}
        {activeTab === "meals" && (
          <div className="row d-flex align-items-center flex-column flex-md-row">
            <div className="col-12 col-md-6 mb-3 mb-md-0">
              <h3 style={{ fontSize: '1.5rem' }}>With Meals</h3>
              <p style={{ fontSize: '1rem' }}>Complement your dining experience with the perfect flavor pairing.</p>

              <div className="mb-3 p-3 bg-light rounded shadow-sm">
                <h6><b>Benefits</b></h6>
                <p>Enhance your meal with a guilt-free, flavorful beverage that aids digestion and elevates your dining experience.</p>
              </div>

              <div className="mb-3 p-3 bg-light rounded shadow-sm">
                <h6><b>Recommended Flavors</b></h6>
                <p>Try Fusion Mojito with spicy foods or Fusion Cranberry with rich, hearty meals.</p>
              </div>

              <div className="p-3 bg-light rounded shadow-sm fst-italic">
                "Fusion Drinks have replaced my usual soda with meals. The subtle flavors complement food without overpowering it."
                <br />
                <span className="text-warning fw-bold">Meera P., Food Blogger</span>
              </div>
            </div>
            <div className="col-12 col-md-6 d-flex justify-content-center">
              <img
                src="https://images.unsplash.com/photo-1593079831268-3381b0db4a77"
                alt="Workout"
                className="img-fluid rounded shadow"
                style={{ maxWidth: '300px', width: '100%' }}
              />
            </div>
          </div>
        )}
      </div>
      {/* Responsive styles */}
      <style>{`
        @media (max-width: 768px) {
          .card {
            padding: 1rem 0.5rem !important;
          }
          .row {
            flex-direction: column !important;
          }
          .col-md-6 {
            width: 100% !important;
            max-width: 100% !important;
          }
          .d-flex.justify-content-between {
            flex-wrap: wrap !important;
            overflow-x: auto !important;
            gap: 0.5rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default TimerCarousel;





// import React, { useState, useEffect, useRef } from "react";
// import "./TimerCarousel.css";
// // import Time from "../../assets/Time.svg";
// // import Role from "../../assets/Role.svg";
// // import Payroll from "../../assets/Payroll.svg";
// // import task from "../../assets/task.svg";
// // import helpdesk from "../../assets/helpdesk.svg";
// // import Devices from "../../assets/Devices.svg";

// const carouselData = [
//   {
//     title: "Pre/Post Workout",
//     des1: "Track employee attendance, work hours, and leaves with automated systems like biometric authentication and web-based login. This eliminates manual errors and improves workforce management accuracy.",
//     des2: "Employees can view their attendance records, apply for leaves, and get real-time approvals. The system also integrates with payroll, ensuring fast salary calculations based on work hours and leave data.",
//     // img: Time,
//     background:
//       "linear-gradient(90deg, hsla(211, 96%, 62%, 1) 0%, hsla(295, 94%, 76%, 1) 100%)",
//   },
//   {
//     title: "On-the-Go",
//     des1: "Grant employees access only to the modules relevant to their roles, ensuring a secure and organized workflow. This minimizes data breaches and unauthorized modifications while streamlining operations.",
//     des2: "With predefined roles such as Admin, HR, Manager, and Employee, permissions are managed efficiently. This system enhances security, improves accountability, and ensures employees have the right tools for their tasks.",
//     // img: Role,
//     background:
//       "linear-gradient(90deg, hsla(265, 53%, 29%, 1) 0%, hsla(24, 93%, 73%, 1) 100%)",
//   },
//   {
//     title: "Daily Hydration",
//     des1: "Automate salary processing with accurate calculations of deductions, bonuses, and tax compliance. This reduces administrative workload and ensures timely salary disbursement.",
//     des2: "Employees can securely access their salary slips, view tax breakdowns, and download reports anytime. Multiple payment options ensure flexibility and compliance with financial regulations.",
//     // img: Payroll,
//     background:
//       "linear-gradient(90deg, hsla(238, 100%, 71%, 1) 0%, hsla(295, 100%, 84%, 1) 100%)",
//   },

// ];

// const TimerCarousel = () => {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [progress, setProgress] = useState(0);
//   const progressIntervalRef = useRef(null);
//   const slideTimeoutRef = useRef(null);

//   useEffect(() => {
//     // Clear any existing intervals or timeouts
//     clearInterval(progressIntervalRef.current);
//     clearTimeout(slideTimeoutRef.current);

//     // Reset progress
//     setProgress(0);

//     // Start progress bar animation
//     progressIntervalRef.current = setInterval(() => {
//       setProgress((prev) => {
//         if (prev < 100) return prev + 1;
//         clearInterval(progressIntervalRef.current);
//         return 100;
//       });
//     }, 30);

//     // Change slide after 3s
//     slideTimeoutRef.current = setTimeout(() => {
//       setActiveIndex((prevIndex) => (prevIndex + 1) % carouselData.length);
//     }, 3000);

//     return () => {
//       clearInterval(progressIntervalRef.current);
//       clearTimeout(slideTimeoutRef.current);
//     };
//   }, [activeIndex]);

//   // Function to handle manual slide change
//   const handleButtonClick = (index) => {
//     setActiveIndex(index);
//     setProgress(0); // Reset progress when user manually changes slide
//   };

//   const activeItemRef = useRef(null);
//   const containerRef = useRef(null);

//   useEffect(() => {
//     if (activeItemRef.current && containerRef.current) {
//       const container = containerRef.current;
//       const activeItem = activeItemRef.current;

//       // Scroll smoothly within the container
//       container.scrollTo({
//         left: activeItem.offsetLeft - container.offsetLeft - 20, // Offset for better alignment
//         behavior: "smooth",
//       });
//     }
//   }, [activeIndex]);

//   return (
//     <div className="timer-carousel-wrapper w-100" style={{ minHeight: '60vh', padding: 0, margin: 0 }}>
//       <div className="container-fluid p-0 m-0">
//         <div className="row flex-column flex-md-row" style={{ minHeight: '60vh', margin: 0 }}>
//           {/* Vertical header column (scrollable on mobile) */}
//           <div className="col-12 col-md-3 d-flex flex-md-column flex-row align-items-stretch justify-content-between overflow-auto" style={{ background: '#f8f9fa', padding: '1rem 0', borderRight: '2px solid #e0e0e0', minHeight: '60px' }}>
//             <div className="d-flex flex-row flex-md-column w-100" style={{ gap: '0.5rem', overflowX: 'auto' }}>
//               {carouselData.map((item, index) => (
//                 <button
//                   key={index}
//                   className={`btn mb-2 ${activeIndex === index ? 'btn-primary text-white fw-bold' : 'btn-light text-dark fw-normal'}`}
//                   style={{
//                     borderRadius: '10px',
//                     fontSize: '1rem',
//                     boxShadow: activeIndex === index ? '0 2px 8px rgba(0,0,0,0.10)' : 'none',
//                     border: activeIndex === index ? '2px solid #007aff' : '2px solid #e0e0e0',
//                     transition: 'all 0.3s',
//                     padding: '0.7rem 0.5rem',
//                     fontWeight: activeIndex === index ? 'bold' : '500',
//                     background: activeIndex === index ? '#007aff' : '#fff',
//                     minWidth: '160px',
//                     whiteSpace: 'nowrap',
//                   }}
//                   onClick={() => handleButtonClick(index)}
//                 >
//                   {item.title}
//                 </button>
//               ))}
//             </div>
//           </div>
//           {/* Full width card */}
//           <div className="col-12 col-md-9 d-flex align-items-center justify-content-center" style={{ minHeight: '60vh', padding: 0 }}>
//             <div
//               className="card shadow-lg border-0 w-100"
//               style={{
//                 background: carouselData[activeIndex].background,
//                 borderRadius: '18px',
//                 padding: '2rem 1rem',
//                 color: '#fff',
//                 margin: '1rem',
//                 transition: 'background 0.5s',
//                 minHeight: '40vh',
//                 maxWidth: '100%',
//                 boxSizing: 'border-box',
//               }}
//             >
//               <h2 className="mb-3" style={{ fontSize: '2rem', fontWeight: 700 }}>{carouselData[activeIndex].title}</h2>
//               <p style={{ fontSize: '1.1rem' }}>{carouselData[activeIndex].des1}</p>
//               <p style={{ fontSize: '1.1rem' }}>{carouselData[activeIndex].des2}</p>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* Responsive styles */}
//       <style>{`
//         @media (max-width: 768px) {
//           .timer-carousel-wrapper .row {
//             flex-direction: column !important;
//           }
//           .timer-carousel-wrapper .col-md-3 {
//             border-right: none !important;
//             border-bottom: 2px solid #e0e0e0 !important;
//             padding: 0.5rem 0 !important;
//           }
//           .timer-carousel-wrapper .col-md-9 {
//             padding: 0 !important;
//           }
//           .timer-carousel-wrapper .card {
//             padding: 1rem 0.5rem !important;
//             margin: 0.5rem !important;
//             min-height: 30vh !important;
//           }
//           .timer-carousel-wrapper .d-flex.flex-row {
//             gap: 0.5rem !important;
//             overflow-x: auto !important;
//             padding-bottom: 0.5rem !important;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default TimerCarousel;
